<template>
  <div class="w-100 section-get-started" :class="$vuetify.display.smAndDown ? 'pa-3' : ' pa-5'">
    <img class="mb-4" :src="dashboardGetStartedImage" alt="dashboard let's get started" />
    <div class="title-text font-weight-bold mb-4" style="font-size: 24px">
      Let's get started with signing up for courses!
    </div>
    <div class="subtitle-text mb-4" style="font-size: 14px; color: #484848">
      Start exploring our course catalog and begin your learning journey today!
    </div>
    <button class="dashboard-sign-up-button px-3 py-2 font-weight-bold" @click="signUpForCourseCta">
      Sign up for courses
    </button>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import dashboardGetStartedImage from '@/assets/images/dashboard-get-started.svg';

import { DataLayerMixin } from '../../mixins/dataLayerMixin';
export default defineComponent({
  name: 'SectionGetStarted',
  mixins: [DataLayerMixin],

  data() {
    return {
      dashboardGetStartedImage
    };
  },

  methods: {
    signUpForCourseCta() {
      this.asuoDataLayerClick('accelerateDashboard', '2');
      this.$router.push('/courses-add');
    }
  }
});
</script>

<style lang="scss" scoped>
.section-get-started {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.dashboard-sign-up-button {
  background-color: #fec627;
  color: #191919;
  border-radius: 999px;
}
</style>
